(ns motorsaif.validation
  (:require
   #?@(:clj [[clojure.pprint :as pprint]]
       :cljs [[goog.string :as gstr :refer [format]]])
   [clojure.string :as str]
   [clojure.walk :as walk]
   [malli.util :as mu]))

(def ^:private phone-prefix-regex #"^(\+|00)")
(def ^:private phone-code-regex (let [phone-codes (str/join "|" (map identity ["971"]))]
                                  (re-pattern (format "^(?:\\+|00)(%s)" phone-codes))))
(def ^:private phone-regex #"^(?:\+|\d)\d{7,16}$")

(def uae-mobile-regex #"^(?:\+971|0)(5\d{8})$")
(def uae-whatsapp [:re
                   ;; {:error/fn :phone/number}
                   uae-mobile-regex])

;; (re-find #"^(?:\\+|\\d)" "+971504290400")

;; (re-find #"^(?:\+).*" "+971504290400")
;; (re-find #"^(?:\+|\d)\d{7,16}$" "+9715040400")
;; (re-find #"^(?:\+971|0)(5\d{8})$" "+971504290400")
;; (re-find #"^(?:\+971|0)(5\d{8})$" "0504290400")
;; (re-find #"\d+" "+971504290400")

(defn- phone-error [{:keys [value]} _]
  (let [has-prefix? (re-find phone-prefix-regex value)
        has-code? (re-find phone-code-regex value)]
    (cond
      (= value "")
      :phone/required
      (not has-prefix?)
      :phone/prefix
      :else
      :phone/number)))

(def password [:string {:min 4 :max 100}])

(def phone [:re
            {:description "Phone",
             :error/fn phone-error}
            phone-regex])

(def ^:private email
  [:re
   {:description "Email",
    :error/message :invalid-email}
   #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$"])

(def car-year [:int {:min 1940 :max 2024}])

(def db-id int?)
(def handle [:re
             {:description "Handle",
              :error/message :invalid-handle}
             #"^[a-zA-Z0-9]{1,}[a-zA-Z0-9.\-_]{2,18}$"])

#_(motorsaif.malli/validate
   handle
   "hsit-0")

(def request-filter
  [:map
   [:type
    [:set {:min 1} [:enum :repairs :upgrades :new-parts :used-parts]]]
   [:makes
    {:optional true}
    [:map-of [:string] [:set [:string]]]]
   [:tag
    {:optional true}
    [:set {:min 1} db-id]]
   [:year
    {:optional true}
    (mu/optional-keys
     [:map
      [:min car-year]
      [:max car-year]])]])

(def request-filters
  [:vector {:min 1} request-filter])

(def ^:private base-media
  [:map
   [:db/id db-id]
   [:media/path [:string {:min 20
                          :max 100}]]
   [:media/order [:int {:min 0
                        :max 100}]]])

(def ^:private base-request-data
  [:map
   [:request
    [:map
     [:request/owner db-id]
     [:request/type [:enum :repair :upgrade :part]]
     ;; [:request/location db-id]
     [:request/geo-location [:string {:min 3}]]
     [:request/coords [:tuple double? double?]]
     [:request/whatsapp
      {:optional true}
      phone]
     ;; [:request/owner db-id]
     [:request/media
      {:optional true}
      [:vector
       {:min 1
        :max 5}
       [:map
        [:db/id db-id]
        [:media/path :string]]]]
     [:request/description
      [:string
       {:min 5
        :max 800}]]
     [:request/category db-id]]]
   [:car
    [:or
     [:map
      [:car/make [:string {:min 3 :max 40}]]
      [:car/model [:string {:min 1 :max 40}]]
      [:car/year car-year]
      [:car/vin {:optional true}
       [:maybe
        [:string {:min 11 :max 17}]]]]
     [:map
      [:db/id db-id]
      [:car/year {:optional true} car-year]
      [:car/make {:optional true} [:string {:min 3 :max 40}]]
      [:car/model {:optional true} [:string {:min 1 :max 40}]]
      [:car/vin {:optional true}
       [:maybe
        [:string {:min 11 :max 17}]]]]]]])

(defn base-request [base-request-stub]
  [:multi {:dispatch #(-> % :request :request/type)}
   [:upgrade base-request-stub]
   [:repair base-request-stub]
   [:part (-> base-request-stub
              (mu/assoc-in [:request :request/type] [:enum :part])
              (mu/assoc-in [:request :part/condition] [:enum :new :used :either]))]])

(comment
  (malli/validate
   [:multi {:dispatch #(-> % :request :request/type)}
    [:general [:map [:request [:request/owner int?]]]
     :parts [:map [:request [:request/owner int?]]]
     ]]
   {:car {}
    :request {:request/owner 3
              :request/type :parts}})

  (-> base-request-data
      (mu/update :request
                 mu/optional-keys)
      (mu/assoc :retracts [:vector
                           {:min 1}
                           any?])
      (mu/optional-keys [:retracts :car])
      (mu/assoc-in [:request :db/id] db-id))

  (-> base-request-data
      (mu/assoc-in [:request :request/type] [:enum :parts])
      (mu/assoc-in [:request :parts/condition] [:enum :new :used :either]))

  (base-request base-request-data)
  ;; (require '[motorsaif.malli :as mm])
  ;; (require '[malli.core :as malli])

  (mm/validate
   [:map
    [:car
     [:or
      [:map
       [:car/make [:string {:min 3 :max 40}]]
       [:car/model [:string {:min 1 :max 40}]]
       [:car/year car-year]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]]
      [:map
       [:db/id db-id]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]]]]]
   {:car {:db/id 17592186045943,
          :car/year 2007
          :car/make "heye"
          :car/model "this"
          :car/vin "111111111131"}})


  (malli/decode [:map
                 [:request
                  [:map
                   [:request/type [:enum :parts]]]]
                 [:car
                  [:map
                   [:car/einfo :string]]]]
                {}
                nil)

  (malli/validate
   [:multi {:dispatch (fn [v] (-> v :request :request/type))}
    [:general [:map [:request [:request/owner int?]]]
     :parts [:map [:request [:request/owner int?]]]

     ]]
   {:car {}
    :request {:request/owner 3
              :request/type :parts}})

  (malli/validate
   [:multi {:dispatch (fn [v]
                        (-> v :request :request/type))}
    [:parts [:map
             [:request
              [:map
               [:request/type [:enum :parts]]]]
             [:car
              [:map
               [:car/part :string]
               [:car/info :string]]]]]
    [:repair [:map
              [:request
               [:map
                [:request/type [:enum :repair :upgrades]]]]
              [:car
               [:map
                [:car/info :string]
                [:car/issue :string]
                ]]]]]
   {:request {:request/type :parts}
    :car {:car/info "honda"
          :car/issue "tet"}})

  (mm/validate
   [:map
    [:car
     [:or
      [:map
       [:car/make [:string {:min 3 :max 40}]]
       [:car/model [:string {:min 1 :max 40}]]
       [:car/year car-year]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]]
      [:map
       [:db/id db-id]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]
       ]
      ]]]
   {:car {:db/id 17592186045943,
          :car/vin "111111111131"}})

  (mm/validate
   [:map
    [:car
     [:or
      [:map
       [:car/make [:string {:min 3 :max 40}]]
       [:car/model [:string {:min 1 :max 40}]]
       [:car/year car-year]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]]
      [:map
       [:db/id db-id]]]]]
   {:car {:db/id 17592186045943}})

  (mm/validate
   [:map
    [:car
     [:or
      [:map
       [:car/make [:string {:min 3 :max 40}]]
       [:car/model [:string {:min 1 :max 40}]]
       [:car/year car-year]
       [:car/vin {:optional true}
        [:maybe
         [:string {:min 11 :max 17}]]]]
      [:map
       [:db/id db-id]]]]]
   {:car {:db/id 17592186045943, :car/make "Honda",
          :car/model "Accord", :car/year 2008}})
  )

(def new-request
  (base-request base-request-data))

;; {:request {:request/category 17592186045439, :request/media [], :db/id 17592186045877}, :audit-user-id 17592186045872}
(def edit-request
  (-> (base-request
       (-> base-request-data
           (mu/update :request mu/optional-keys)
           (mu/assoc :retracts [:vector
                                {:min 1}
                                any?])
           (mu/optional-keys [:retracts :car])
           (mu/assoc-in [:request :db/id] db-id)))
      (mu/update-in  [:part :request] #(mu/optional-keys % [:part/condition]))))


;; [:part
;;  [:map
;;   [:request [:map [:request/owner {:optional true} int?]
;;              [:request/type {:optional true} [:enum :part]
;;               ]
;;              [:request/geo-location {:optional true} [:string {:min 3}]]
;;              [:request/coords {:optional true} [:tuple double? double?]]
;;              [:request/whatsapp {:optional true} [:re {:description "Phone", :error/fn #function[motorsaif.validation/phone-error]} #"^(?:\+|\d)\d{7,16}$"]] [:request/media {:optional true} [:vector {:min 1, :max 5} [:map [:db/id int?] [:media/path :string]]]] [:request/description {:optional true} [:string {:min 5, :max 800}]] [:request/category {:optional true} int?] [:db/id int?] [:part/condition {:optional true} [:enum :new :used :either]]]]
;;   [:car {:optional true}
;;    [:or [:map [:car/make [:string {:min 3, :max 40}]]
;;          [:car/model [:string {:min 1, :max 40}]]
;;          [:car/year [:int {:min 1940, :max 2024}]]
;;          [:car/vin {:optional true} [:maybe [:string {:min 11, :max 17}]]]]
;;     [:map [:db/id int?] [:car/vin {:optional true} [:maybe [:string {:min 11, :max 17}]]]]]] [:retracts {:optional true} [:vector {:min 1} any?]]]]

(def message-base
  [:or
   [:map ; Message with only media no body
    [:db/id {:optional true} db-id]
    [:message/thread
     [:tuple db-id db-id]]
    [:message/from db-id] ;; can be user or dealer
    [:message/media
     [:vector
      {:min 1
       :max 4}
      [:map
       [:db/id db-id]
       [:media/path :string]]]]]
   [:map ; Message with body and potentially media
    [:db/id {:optional true} db-id]
    [:message/thread
     [:tuple db-id db-id]]
    [:message/from db-id] ;; can be user or dealer
    [:message/body [:string {:min 1 :max 2300}]]
    [:message/media
     {:optional true}
     [:vector
      {:max 4}
      [:map
       [:db/id db-id]
       [:media/path :string]]]]]])

(def message
  [:map
   [:uuid uuid?]
   [:message message-base]])

(def user-base [:map
                [:user/name [:string {:min 2 :max 40}]]
                [:user/handle handle] ;; can be request-id or a reply to another message
                [:user/handle-valid [:enum true]]
                [:user/email email] ;; can be request-id or a reply to another message
                [:user/email-verified [:enum true]]
                [:user/password [:string {:min 2 :max 100}]] ;; can be request-id or a reply to another message
                ])


(def verify-email
  [:map
   [:user
    [:map
     [:db/id db-id]
     [:user/email email]]]])

(def edit-profile
  (-> [:map
       [:user
        (mu/merge
         [:map
          [:db/id db-id]]
         [:and
          (mu/optional-keys
           [:map
            [:user/handle handle]
            [:user/status [:enum :verified :unverified]]
            [:user/name [:string {:min 2 :max 40}]]
            [:user/email email]
            [:user/phone phone]
            [:user/password [:string {:min 2 :max 100}]]
            [:user/password-confirm [:string {:min 2 :max 100}]]])
          [:fn {:error/message "passwords don't match"
                :error/key :password-mismatch}
           (fn [{:user/keys [password password-confirm]}]
             (= password password-confirm))]])]]))
(comment
  (motorsaif.malli/validate
   update-user
   {:user {:db/id 17592186045449
           :user/email "naomarikomar@naomarik.com"}}))

(def sign-up
  ;; [:map [:user/handle-valid boolean]]
  [:map [:user
         (-> user-base
             (mu/select-keys [:user/handle
                              :user/handle-valid
                              :user/email
                              :user/email-verified
                              :user/password])
             )]])

(def forgot-password
  [:map
   [:email email]])

(def verify-code
  [:map
   [:email email]
   [:nonce [:string {:min 4 :max 8}]]
   [:password {:optional true} password]])

(def login
  [:map
   [:user/auth-identity [:string {:min 2 :max 30}]] ;; can be request-id or a reply to another message
   [:user/password password] ;; can be request-id or a reply to another message
   ])

(def ^:private business-base
  [:map
   {:closed true}
   [:business/email email]
   [:business/name [:string
                    {:min 3
                     :max 200}]]
   [:business/description
    {:optional true}
    [:string
     {:min 5
      :max 200}]]
   [:business/misc
    {:optional true}
    [:map
     [:filters request-filters]
     [:insta
      {:optional true}
      [:string
       {:min 3 :max 40}]]
     [:whatsapp
      {:optional true}
      uae-whatsapp]
     [:whatsapp-verify-code
      {:optional true}
      any?]
     [:whatsapp-verified
      {:optional true}
      true?]
     [:phone
      {:optional true}
      phone]
     [:hours
      {:optional true}
      [:string
       {:min 0 :max 100}]]]]
   ;; [:business/location db-id]
   [:business/coords
    [:tuple double? double?]]
   [:business/media
    [:vector
     {:min 1
      :max 8}
     [:map
      [:db/id db-id]
      [:media/order int?]
      [:media/path :string]]]]])

(def ^:private retract-entities
  [:vector
   [:tuple keyword? db-id]])

(def ^:private roles-base
  [:map
   [:role/target db-id]
   [:role/owner db-id]
   [:role/level int?]])

(def new-business
  [:map
   [:business business-base]])

(def business-signup
  [:map
   [:business (-> business-base
                  (mu/select-keys [:business/name
                                   :business/coords
                                   :business/misc
                                   :business/email])
                  (mu/assoc-in [:business/misc :filters] request-filters)
                  (mu/required-keys [:business/misc]))]])

(def business+owner-signup
  [:map
   [:user
    (-> user-base
        (mu/select-keys
         [:user/handle
          :user/handle-valid
          :user/email-verified
          :user/email
          :user/password]))]
   [:business
    (-> business-base
        (mu/select-keys [:business/name
                         :business/coords
                         :business/misc
                         :business/email])
        (mu/assoc-in [:business/misc :filters] request-filters)
        (mu/required-keys [:business/misc])
        (mu/update-in  [:business/misc]
                       #(mu/required-keys % [:whatsapp]))
        #_(mu/optional-keys))]])

(comment
  (-> business-base
      (mu/select-keys [:business/name
                       :business/email])
      (mu/assoc-in [:business/misc :filters] request-filter)
      (mu/required-keys [:business/misc])
      #_(mu/optional-keys))
  (-> business-base
      (mu/select-keys [:business/name
                       ])
      (mu/assoc-in [:business/misc :filters] request-filter)
      (mu/required-keys [:business/misc])
      #_(mu/optional-keys))

  (motorsaif.malli/validate
   business+owner-signup
   {:business {:business/name "ddfdf"
               :business/misc {:filters [{:type #{:upgrades :new-parts}, :tag #{17592186045436}, :makes {"Acura" #{}}}]}}})
  )

#?(:cljs
   (do
     (def edit-business
       [:map
        [:roles {:optional true} roles-base]
        [:retracts {:optional true} [:vector {:min 1} any?]]
        [:retract-entities {:optional true} retract-entities]
        [:business (-> business-base
                       (mu/assoc-in [:business :db/id] db-id)
                       (mu/optional-keys)
                       (mu/required-keys [:db/id]))]])))

;; TODO: Move these into another NS???
#?(:clj
   (do
     ;; TODO db/id is not optional
     (def edit-message
       [:map
        [:uuid uuid?]
        [:message message-base]])

     (def update-user edit-profile)
     (def update-user edit-profile)

     (def verify-account
       [:map [:user-id db-id]])

     (def registration-email
       [:map
        [:user/email email]])

     ;; Transaction validations

     (def update-request-status
       [:map
        [:audit-user-id db-id]
        [:request
         [:map
          [:db/id db-id]
          [:request/status [:enum :active :expired :resolved :deleted]]]]])

     (def create-business-with-owner
       [:map
        [:audit-user-id db-id]
        [:owner-id db-id]
        [:business (-> business-base
                       (mu/optional-keys [:business/media]))]])

     (def create-business
       [:map
        [:audit-user-id db-id]
        [:business (-> business-base
                       (mu/optional-keys [:business/media]))]])

     (def create-message
       [:map
        [:audit-user-id db-id]
        [:message
         (-> message-base)]])

     (def create-request
       (base-request (-> base-request-data
                         (mu/assoc-in [:request :request/owner] db-id))))

     (def create-user-stub
       [:map
        [:user
         (-> user-base
             (mu/select-keys [:user/email]))]])

     (def create-user
       [:map
        [:user
         (-> user-base
             (mu/select-keys [:user/handle
                              :user/email
                              :user/password]))]])

     (def create-business
       [:map
        [:audit-user-id db-id]
        [:business (-> business-base
                       (mu/optional-keys [:business/media]))]])

     (def edit-business
       [:map
        [:audit-user-id db-id]
        [:roles {:optional true} roles-base]
        [:retract-entities {:optional true} retract-entities]
        [:retracts {:optional true} [:vector {:min 1} any?]]
        [:business (-> business-base
                       (mu/assoc-in [:business :db/id] db-id)
                       (mu/optional-keys)
                       (mu/required-keys [:db/id]))]])))

(comment
  ;; (motorsaif.malli/validate
  ;;  [:enum :active :expired :resolved :deleted]
  ;;  :resolved)

  (motorsaif.malli/validate
   (-> [:map
        [:user
         [:db/id db-id]
         [:and
          (mu/optional-keys
           [:map
            [:user/handle handle]
            [:user/name [:string {:min 2 :max 40}]]
            [:user/email email]
            [:user/password [:string {:min 2 :max 100}]]
            [:user/password-confirm [:string {:min 2 :max 100}]]])
          [:fn {:error/message "passwords don't match"}
           (fn [{:user/keys [password password-confirm]}]
             (= password password-confirm))]]]])
   {:user {:user/handle 3}})

  (motorsaif.malli/validate
   [:map
    [:audit-user-id db-id]
    [:request
     [:map
      [:db/id db-id]
      [:request/status [:enum :active :expired :resolved :deleted]]]]]
   {:request {:db/id 17592186047261, :request/status :resolved},
    :audit-user-id 17592186045449})


  (motorsaif.malli/validate
   create-user
   {:user
    {:user/handle "7.manai",
     :user/email "omar@test.com",
     :user/password
     "bcrypt+sha512$d21992878e63b936010e1a55ed4fd4c7$12$3323dbea51794c23b5ae58b628409a00c853c6ffa75db818"}})
  )
